"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareModal = exports.ShareContent = void 0;
Object.defineProperty(exports, "useCopyToClipBoard", {
  enumerable: true,
  get: function get() {
    return _shareHook.useCopyToClipBoard;
  }
});
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../elements/button/Button");
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _ShareIosOutlined = require("../icons/ShareIosOutlined");
var _Modal = require("../modal/Modal");
var _ShareButtons = require("./ShareButtons");
var _shareHook = require("./shareHook");
var _ShareModalModule = _interopRequireDefault(require("./ShareModal.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ShareContent = exports.ShareContent = function ShareContent(_ref) {
  var handleCopy = _ref.handleCopy,
    copied = _ref.copied,
    inputElement = _ref.inputElement,
    url = _ref.url;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _ShareModalModule.default.shareForm,
    "data-jlds": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.default, {
      ref: inputElement,
      ariaLabel: "Share URL",
      className: _ShareModalModule.default.shareInput,
      defaultValue: url,
      id: "url",
      name: "url"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
      className: _ShareModalModule.default.copyButton,
      "data-testid": "share-modal-copy-link-button",
      onClick: handleCopy,
      children: copied ? 'Copied to clipboard' : 'Copy link'
    })]
  });
};
ShareContent.propTypes = {
  /**
   *  callback function for copy link button is clicked
   */
  handleCopy: _propTypes.default.func.isRequired,
  /**
   *  copied boolean state
   */
  copied: _propTypes.default.bool.isRequired,
  /**
   *  url to be shared
   */
  url: _propTypes.default.string.isRequired,
  /**
   *  DOM node reference for input element
   */
  inputElement: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]).isRequired
};
var ShareModal = exports.ShareModal = function ShareModal(_ref2) {
  var url = _ref2.url,
    title = _ref2.title,
    image = _ref2.image,
    handleShare = _ref2.handleShare,
    isModalOpen = _ref2.isModalOpen,
    closeModal = _ref2.closeModal,
    shareContent = _ref2.shareContent,
    className = _ref2.className;
  var encodedTitle = encodeURIComponent(title);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
      IconComponent: _ShareIosOutlined.ShareIosOutlined,
      className: className,
      "data-testid": "share-modal-button",
      onClick: handleShare,
      small: true,
      children: "Share"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
      "data-jlds": true,
      footer: false,
      isOpen: isModalOpen,
      onClose: closeModal,
      title: "Share",
      width: "large",
      children: [shareContent, /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _ShareModalModule.default.description,
        children: "You can copy this link into emails, text messages or post it on social media."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _ShareModalModule.default.heading,
        children: "Share now"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShareButtons.ShareButtons, {
        image: encodeURIComponent(image),
        title: encodedTitle,
        url: url
      })]
    })]
  });
};
ShareModal.propTypes = {
  /**
   * product url that needs to be shared
   */
  url: _propTypes.default.string.isRequired,
  /**
   * Pinterest sharing requires adding a image url
   */
  image: _propTypes.default.string.isRequired,
  /**
   * Product title information
   */
  title: _propTypes.default.string.isRequired,
  /**
   *  callback function to be called when share button is clicked
   */
  handleShare: _propTypes.default.func.isRequired,
  /**
   *  isModalOpen boolean state to track when modal is open or not
   */
  isModalOpen: _propTypes.default.bool.isRequired,
  /**
   *  Placeholder fro ShareContent component
   */
  shareContent: _propTypes.default.node.isRequired
};